import React from 'react'
import ReactDOM from 'react-dom'
import 'dayjs/locale/fr'
import './index.less'
import reportWebVitals from './reportWebVitals'
import Router from './components/Router'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import { ProvideAuth } from './providers/auth.provider'
import dayjs from 'dayjs'
import { createGlobalStyle } from 'styled-components'
import ApolloProviderWrapper from './providers/apollo.provider'
import { ConfigProvider } from 'antd'
import frFR from 'antd/lib/locale/fr_FR'

dayjs.locale('fr')

if (process.env.NODE_ENV === 'production') {
  console.log('init sentry')

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_URL,
    autoSessionTracking: true,
    integrations: [new Integrations.BrowserTracing()],
    environment: process.env.REACT_APP_TARGET_BUILD,
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'TypeError: NetworkError when attempting to fetch resource',
      'TypeError: Failed to fetch',
    ],
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  })
}

const GlobalStyles = createGlobalStyle`
  :root {
    --darkest-grey: #444;
    --light-grey: #505050;
    --lightest-grey: #f5f5f5;
  }

  body {
    margin: 0;
    background-color: var(--lightest-grey);
    font-family: 'Ubuntu', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .ant-cascader-menu {
    height: 500px;
  }
`

ReactDOM.render(
  <React.StrictMode>
    <GlobalStyles />
    <ApolloProviderWrapper>
      <ProvideAuth>
        <ConfigProvider locale={frFR}>
          <Router />
        </ConfigProvider>
      </ProvideAuth>
    </ApolloProviderWrapper>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
